"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var MarketplaceConfigContext = /** @class */ (function () {
    function MarketplaceConfigContext(marketplaceId) {
        this._marketplaceId = marketplaceId;
    }
    MarketplaceConfigContext.prototype.toRawContext = function () {
        var context = new Map();
        context.set("acs_marketplace_id", this._marketplaceId);
        return new amazon_config_store_type_script_client_1.QueryContext(context);
    };
    Object.defineProperty(MarketplaceConfigContext.prototype, "marketplaceId", {
        get: function () {
            return this._marketplaceId;
        },
        set: function (value) {
            this._marketplaceId = value;
        },
        enumerable: false,
        configurable: true
    });
    return MarketplaceConfigContext;
}());
exports.default = MarketplaceConfigContext;
